import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';
import arSA from './locales/ar-SA';
import esES from './locales/es-ES';
import ptPT from './locales/pt-PT';
import ruRU from './locales/ru-RU';
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: sessionStorage.getItem('lang') || 'en-US', // 默认语言，可从本地存储获取
    messages: {
        'zh-CN': zhCN,
        'en-US': enUS,
        'ar-SA': arSA,
        'es-ES': esES,
        'pt-PT': ptPT,
        'ru-RU': ruRU
    }
});

export default i18n;
